// extracted by mini-css-extract-plugin
export default {"wrapper":"McStackedBars_wrapper__XE4hd"};